<template>
  <el-container class="index-con">
    <div class="index-header" style="border-bottom: solid 1px #e6e6e6;">
      <navcon></navcon>
    </div>

    <div class="index-page"></div>

    <!-- banner -->
    <div class="banner">
      <el-carousel trigger="click" :height="height + 'px'">
        <el-carousel-item v-for="item,index in banner" :key="index">
          <img class="banner" ref="height1" @load="imgLoad" :src="item.bannerImg" @click="onTransParam(item.transParam)">
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 认证简介 -->
    <div style="background-color: #f5f6f8;padding-top: 40px;">
      <div class="main-con">
        <div class="authentication">
          <h2>认证简介</h2>
          <p class="underline"></p>
          <div class="authentication-list">
            <ul>
              <li class="type" :class="type==1?'cur':''" @click="onCur(1)">Vastbase认证</li>
              <li class="type" :class="type==2?'cur':''" @click="onCur(2)">openGauss认证</li>
            </ul>
          </div>
          <div class="grade">
            <ul>
              <li v-for="item in certListVastBase" :key="item.id" v-if="type==1">
                <div class="title">
                  <img :src="item.certIcon" alt="">
                  <p>{{item.certName}}</p>
                </div>
                <p class="text">{{item.certDesc}}</p>
                <el-button class="button" size="small" type="warning" @click="onCert(item.id)" style="background-color: #ff821c">查看详情</el-button>
              </li>
              <li v-for="item in certListOpenGauss" :key="item.id" v-if="type==2">
                <div class="title">
                  <img :src="item.certIcon" alt="">
                  <p>{{item.certName}}</p>
                </div>
                <p class="text">{{item.certDesc}}</p>
                <el-button style="background-color: #ff821c" class="button" size="small" type="warning" @click="onCert(item.id)">查看详情</el-button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 认证价值 -->
    <div style="background-color: #fff;padding: 40px 0 30px;">
      <div class="main-con">
        <div class="authentication">
          <h2>认证价值</h2>
          <p class="underline"></p>
          <div class="worth worth1" v-if="certType==1">
            <div class="vastbase">
              <p class="title">Vastbase<span>认证价值</span></p>
              <ul class="vastbase-list">
                <li v-for="item in certificateValueVastBase" :key="item.id">
                  <p class="name">{{item.name}}</p>
                  <p class="text">{{item.value}}</p>
                </li>
              </ul>
            </div>
            <div class="openGauss">
              <div class="openGauss-ww" @mouseenter="onCertificate(2)">
                <p class="title"  style="padding-bottom: 24px;margin-bottom: 0;color: #000;">openGauss<span style="color: #000;">认证价值</span></p>
                <ul class="openGauss-list">
                  <li v-for="item,index in certificateValueOpenGauss" :key="index" v-if="index==0">
                    <p class="name" style="border-left: 0;padding-left: 0">{{item.name}}</p>
                    <p class="text">{{item.value}}</p>
                  </li>
                </ul>
                <!-- <p class="learn-more">了解详情 ></p> -->
              </div>
            </div>
          </div>
          <div class="worth worth2" v-else>
            <div class="openGauss" style="padding-left: 0;">
              <div class="openGauss-ww" @mouseenter="onCertificate(1)">
                <p class="title"  style="padding-bottom: 24px;margin-bottom: 0;color: #000;width: 70%;">Vastbase<span style="color: #000;">认证价值</span></p>
                <ul class="openGauss-list" style="width: 55%;">
                  <li v-for="item,index in certificateValueVastBase" :key="index" v-if="index==0">
                    <p class="name" style="border-left: 0;padding-left: 0">{{item.name}}</p>
                    <p class="text">{{item.value}}</p>
                  </li>
                </ul>
                <!-- <p class="learn-more">了解详情 ></p> -->
              </div>
            </div>
            <div class="vastbase" style="padding-right: 0;">
              <p class="title" style="text-align: right;">openGauss<span>认证价值</span></p>
              <ul class="vastbase-list">
                <li v-for="item in certificateValueOpenGauss" :key="item.id">
                  <p class="name">{{item.name}}</p>
                  <p class="text">{{item.value}}</p>
                </li>
              </ul>
            </div>
            
          </div>
        </div>
      </div>
    </div>

    <!-- 认证流程 -->
    <div style="background-color: #F1F4F6;padding: 40px 0 60px;">
      <div class="main-con">
        <div class="authentication">
          <h2>认证流程</h2>
          <p class="underline"></p>
          <div class="procedure">
            <ul>
              <li v-for="item,index in certificateFlow" :key="item.id" v-if="index==0">
                <div style="position: relative; box-shadow: 0px 18px 26px 1px #E6E6EA;">
                  <img class="backimg" src="../../assets/img/flowIcon1.png">
                  <div class="content">
                    <h4>{{ item.name }}</h4>
                    <p>{{ item.value }}</p>
                  </div>
                </div>
              </li>
              <img class="jiantou" src="../../assets/img/icon12.png">
              <li v-for="item,index in certificateFlow" :key="item.id" v-if="index==1">
                <div style="position: relative; box-shadow: 0px 18px 26px 1px #E6E6EA;">
                  <img class="backimg" src="../../assets/img/flowIcon2.png">
                  <div class="content">
                    <h4>{{ item.name }}</h4>
                    <p>{{ item.value }}</p>
                  </div>
                </div>
              </li>
              <img class="jiantou" src="../../assets/img/icon12.png">
              <li v-for="item,index in certificateFlow" :key="item.id" v-if="index==2">
                <div style="position: relative; box-shadow: 0px 18px 26px 1px #E6E6EA;">
                  <img class="backimg" src="../../assets/img/flowIcon3.png">
                  <div class="content">
                    <h4>{{ item.name }}</h4>
                    <p>{{ item.value }}</p>
                  </div>
                </div>
              </li>
              <img class="jiantou" src="../../assets/img/icon12.png">
              <li v-for="item,index in certificateFlow" :key="item.id" v-if="index==3">
                <div style="position: relative; box-shadow: 0px 18px 26px 1px #E6E6EA;">
                  <img class="backimg" src="../../assets/img/flowIcon4.png">
                  <div class="content">
                    <h4>{{ item.name }}</h4>
                    <p>{{ item.value }}</p>
                  </div>
                </div>
              </li>
              <img class="jiantou" src="../../assets/img/icon12.png">
              <li v-for="item,index in certificateFlow" :key="item.id" v-if="index==4">
                <div style="position: relative; box-shadow: 0px 18px 26px 1px #E6E6EA;">
                  <img class="backimg" src="../../assets/img/flowIcon5.png">
                  <div class="content">
                    <h4>{{ item.name }}</h4>
                    <p>{{ item.value }}</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 在线课程 -->
    <div style="background-color: #fff;padding: 40px 0 60px;">
      <div class="main-con" style="padding-bottom: 20px;">
        <div class="authentication">
          <h2>在线课程</h2>
          <p class="underline" style="margin-bottom: 36px;"></p>
          <div class="curriculum enroll-list" style="margin-bottom: 0">
            <ul>
              <li v-for="item,index in curriculumItem" :key="index" v-show="index>=minnum && index<maxnum" style="margin-bottom: 0;" @click="onClassroomDetails(item.id)">
                <div class="enroll-list-play">
                  <img class="enroll-list-img" :src="item.courseImg">
                  <img class="enroll-list-icon" src="../../assets/img/icon4.png">
                </div>
                <div class="enroll-list-content">
                  <p class="enroll-list-name">{{item.courseName}}</p>
                  <p class="enroll-list-time">{{item.createTime.split(" ")[0]}}
                    <!-- <span>|</span>难度：{{ item.difficulty }} -->
                  </p>
                  <p class="enroll-list-abstract" v-html="item.courseDesc"></p>
                  <div style="display: flex;align-items: center; ">
                    <el-button  size="small" type="warning" round @click="onButton(1)" style="padding: 7px 16px;background-color: #ff821c">开始学习</el-button>
                    <p class="enroll-list-intotal-number">{{item.learnCount}}人学习</p>
                  </div>
                </div>
              </li>
            </ul>
            <div class="zjiant">
              <img src="../../assets/img/icon10.png" style="cursor:no-drop" v-if="minnum<=0">
              <img src="../../assets/img/icon11.png" style="cursor: pointer;" @click="onPrev" v-else>
            </div>
            <div class="yjiant">
              <img src="../../assets/img/icon8.png" style="cursor: pointer;" @click="onNext" v-if="maxnum<curriculumItem.length">
              <img src="../../assets/img/icon9.png" style="cursor:no-drop" v-else>
            </div>
          </div>
          <div style="text-align: center;margin-top: 48px;">
            <el-button class="button" style="padding: 16px 60px; width: auto;background-color: #ff821c" size="small" type="warning" @click="onClassroom">更多课程</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 考试中心 -->
    <div style="background-color: #F1F4F6;padding: 40px 0 20px;">
      <div class="main-con">
        <div class="authentication">
          <h2>考试中心</h2>
          <p class="underline"></p>
          <div class="testingCenter">
            <div class="testingCenter-left" v-for="item,index in examItem" :key="index" v-if="index==0" @click="onExamDetails(item.id)">
              <div class="exam-img">
                <img :src="item.examImg">
              </div>
              <div class="title">
                <p class="text">{{item.examName}}</p>
                <img class="icon" src="../../assets/img/icon19.png" alt="">
              </div>
              <div class="on-line">
                <p class="type" style="width: 40px;">{{item.examForm==1?'线上':'线下'}}</p>
                <i class="el-icon-suitcase-1" style="font-size: 12px;color: #c4c3c6;"></i>
                <p class="time">{{item.examStartTime.split(" ")[0]}}-{{ item.examEndTime.split(" ")[0] }}</p>
              </div>
              <el-divider></el-divider>
              <p class="introduce">{{ item.examIntro }}</p>
            </div>
            <div class="testingCenter-right">
              <ul class="infinite-list" v-infinite-scroll="load" style="overflow:auto">
                <li v-for="item,index in examItem" :key="index" class="infinite-list-item"  @click="onExamDetails(item.id)" v-if="index>0">
                  <div class="infinite-list-div">
                    <img :src="item.examImg">
                  </div>
                  <div class="content">
                    <div class="title">{{item.examName}}</div>
                    <div class="on-line">
                      <p class="type" style="width: 40px;">{{item.examForm==1?'线上':'线下'}}</p>
                      <i class="el-icon-suitcase-1" style="font-size: 12px;color: #c4c3c6;"></i>
                      <p class="time">{{item.examStartTime.split(" ")[0]}}-{{ item.examEndTime.split(" ")[0] }}</p>
                    </div>
                    <p class="learn-more" style="margin-top: 6px;">了解详情 ></p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div style="text-align: center;">
            <el-button class="button" style="padding: 16px 60px; width: auto;background-color: #ff821c" size="small" type="warning" @click="submitExam">更多考试</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 常见问题 -->
    <div style="background-color: #fff;padding: 40px 0">
      <div class="main-con">
        <div class="authentication">
          <h2>常见问题</h2>
          <p class="underline"></p>
          <div class="problem">
            <el-collapse v-model="activeNames" @change="handleChange" accordion>
              <el-collapse-item v-for="item,index in helpCenter" :key="item.id" v-if="index<3">
                <template slot="title">
                  <div class="questions-and-answers">
                    <img src="../../assets/img/icon13.png" alt="">
                    <p>问答</p>
                  </div>
                  <p class="titles">{{ item.name }}</p>
                </template>
                <div class="text">{{ item.value }}</div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <div style="text-align: center;margin-top: 48px;">
            <el-button class="button" style="padding: 16px 60px; width: auto;background-color: #ff821c" size="small" type="warning" @click="onHelpCenter">查看更多</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- product -->
    <!-- <div>
      <div class="product">
        <div>
          <h2>构建自主产品体现，释放海量数据价值</h2>
          <div class="button">
            <el-button style="background-color: #ff821c" size="small" type="warning">立即咨询</el-button>
            <el-button size="small" type="warning" style="background-color: #fff;border: none;color: #f69803;">立即体验</el-button>
          </div>
        </div>
      </div>
    </div> -->

    <el-footer class="index-footer" style="height: auto; background-color: #f0f4f7;border-top: solid 1px #e6e6e6">
      <footers></footers>
    </el-footer>
    
  </el-container>
</template>
<script>
// 导入组件
import navcon from '../../components/navcon.vue'
import footers from '../../components/footers.vue'
import { bannerList, homeInfo,courseList,examList } from '../../api/userMG'
export default {
  name: 'index',
  data() {
    return {
      showclass: 'asideshow',
      type:1,
      count: 1,
      activeNames: ['1'],
      certListVastBase:[],
      certListOpenGauss:[],
      curriculumItem:[],
      minnum:0,
      maxnum:3,
      certType:1,
      certificateValueVastBase:[],
      certificateValueOpenGauss:[],
      certificateFlow:[],
      helpCenter:[],
      examItem:[],
      banner:[],
      height:""
    }
  },
  // 注册组件
  components: {
    navcon,
    footers,
  },
  computed: {
    url() {
      return this.$store.getters.url;
    }
  },
  created() {
    this.getBannerList()
    this.getHome();
    this.getCourse();
    this.getExamList();
  },
  mmounted() {
    this.imgLoad()
    window.addEventListener('resize',()=>{
      this.height =  this.$refs.height1[0].height
      this.imgLoad()
    })
  },
  // beforeUpdate() {},
  // // 挂载前状态(里面是操作)
  // beforeMount() {
  //   // 弹出登录成功
  //   this.$message({
  //     message: '登录成功',
  //     type: 'success'
  //   })
  // },
  methods:{
    imgLoad(){
      var _that = this
      this.$nextTick(()=>{
        _that.height = _that.$refs.height1[0].height
        _that.$emit('style1',_that.height)//如果是子组件，就给父组件传递高度，设定父组件的高度
      })
    },
    // 获取banner
    getBannerList(){
      bannerList({location:1}).then(res => {
        console.log('banner',res.data);
        this.banner = res.data
      })
      .catch(err => {})
    },
    onTransParam(url){
      if(url){
        window.open(url)
      }
    },
    async getHome(){
      // const loading = this.$loading({
      //   lock: true,
      //   text: '加载中',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // });
      await homeInfo().then(res => {
        // loading.close();
        console.log('首页数据',res);
        // banner
        // this.banner = res.data.banner;
        // 认证
        this.certListVastBase = res.data.certListVastBase;
        this.certListOpenGauss = res.data.certListOpenGauss;
        // Vastbase认证价值
        this.certificateValueVastBase = res.data.certificateValueVastBase;
        // openGauss认证价值
        this.certificateValueOpenGauss = res.data.certificateValueOpenGauss;
        // 认证流程
        this.certificateFlow = res.data.certificateFlow;
        // 常见问题
        this.helpCenter = res.data.helpCenter
      })
    },
    // 获取课程
    async getCourse(){
      await courseList().then(res => {
        console.log('课程数据',res.data.content);
        this.curriculumItem = res.data.content
      })
    },
    // 获取考试报名列表
    async getExamList(){
      // let params = {
      //   page:this.page,
      //   rows:this.rows,
      // }
      await examList().then(res => {
        this.examItem = res.data.content;
        console.log('考试数据',this.examItem)
      })
      .catch(err => {
        this.loading = false
      })
    },
    // 跳转考试报名详情
    onExamDetails(id){
      this.$router.push({path:'/index/examDetails', query: { id: id,type:1 }})
    },
    onCur(e){
      this.type = e;
    },
    load () {
      this.count = 10
    },
    handleChange(val) {
      console.log(val);
    },
    onPrev(){
      this.minnum -= 3;
      this.maxnum -= 3;
      this.$forceUpdate
    },
    onNext(){
      this.minnum += 3;
      this.maxnum += 3;
      this.$forceUpdate
    },
    onCertificate(e){
      this.certType = e;
    },
    onCert(id){
      this.$router.push({path:'/index/certificationDetails', query: { id: id }})
    },
    onClassroom(){
      this.$router.push({path:'/index/classroom'})
    },
    onClassroomDetails(id){
      this.$router.push({path:'/index/classroomDetails',query: { id: id, type:1 }})
    },
    submitExam(){
      this.$router.push({path:'/index/exam'})
    },
    onHelpCenter(){
      this.$router.push({path:'/index/support?id=1'})
    }
  }
}
</script>

<style scoped>
  .banner{
    width: 100%;
    cursor: pointer;
  }
  @media (min-width: 1366px) {
    .main-con { 
        width: 1000px;
      }
    }
  @media (min-width: 1600px) {
    .main-con {
      width: 1300px;
    }
  }
  .aside-main{
    display: flex;
  }
  .main-con {
    margin: auto;
    padding-bottom: 40px;
  }
  .index-con {
    height: 100%;
    box-sizing: border-box;
    margin: auto;
  }
  .breadcrumb{
    padding: 30px 0;
  }
  .breadcrumb span{
    font-size: 12px;
  }
  .aside {
    width: 64px !important;
    height: 100%;
    background-color: #334157;
    margin: 0px;
  }
  .asideshow {
    width: 240px !important;
    height: 100%;
    margin: 0px;
  }
  .index-main{
    margin-left: 20px !important;
  }

  .index-header,
  .index-main,
  .index-footer {
    padding: 0px;
    height: auto;
    margin: 0; 
  }

  /* .index-header{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    background: #fff;
  }
  .index-page{
    margin-top: 73px;
  } */
  h2{
    text-align: center;
    color: black;
  }
  .underline{
    width: 20px;
    height: 2px;
    background: #ff821c;
    margin: auto;
  }
  /* .authentication{
    background-color: #f5f6f8;
  }  */
   .authentication-list{
    margin-top: 20px;
    margin-bottom: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #dddee0;

  }
  .authentication-list ul{
    display: flex;
    align-items: center;
  }
  .authentication-list ul li{
    font-size: 13px;
    padding: 10px 0;
    margin:  0 30px;
    cursor: pointer;
    border-bottom: 2px solid #f5f6f8;
    font-size: 16px;
    color: #999999;
  }
  .cur{
    color: #ff821c !important;
    border-bottom: 2px solid #ff821c !important;
  }
  .grade ul{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .grade ul li{
    background-color: #f8f9fb;
    width: 27.2%;
    padding: 20px 24px;
    box-shadow: 0 0 20px rgba(222, 207, 207, 0.8);
    border: 1px solid #e8e9ed;
    border-top: none;
    border-radius: 10px;
    margin-right: 17px;
    margin-bottom: 17px;
    transition: transform 0.3s ease-in-out; /* 动画持续时间和动画类型 */
    transform: translateY(0); /* 初始状态，不移动 */
  }
  .grade ul li:nth-child(3), .grade ul li:nth-child(6){
    margin-right: 0;
  }
  .grade ul li:hover{
    background-image: linear-gradient(bottom,#f9efe3 , #fff);
    transform: translateY(-10px)
  }
  .grade ul li .title{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f0f1f3;
    padding:10px 8px 16px;
    margin-bottom: 12px;
  }
  .grade ul li .title img{
    width: 25px;
    margin-right: 10px;
  }
  .grade ul li .title p{
    font-size: 16px;
    color: black;
  }
  .grade ul li .text{
    font-size: 12px;
    color: #686868;
    margin-bottom: 28px;
    overflow:hidden;
    word-wrap: break-word;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2; 
  }
  .grade .button{
    width: 100%;
    height: auto;
  }
  .worth{
    margin-top: 34px;
    height: 300px;
    background-repeat: no-repeat;
    background-position: center right;
    background-size: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px 0;
    animation: slideBackground 5s infinite alternate;
  }
  @keyframes slideBackground {
    0% {
      background-position: center center;
    }
    100% {
      background-position: right center;
    }
  }
  .worth1{
    background-image: url('../../assets/img/back3.png');
  }
  .worth2{
    background-image: url('../../assets/img/back5.png');
  }
  .vastbase{
    width: 65%;
    padding-right: 40px;
  }
  .vastbase .title, .openGauss .title{
    font-size: 24px;
    color: #ff821c;
    font-weight: 600;
    margin-bottom: 40px;
    cursor: pointer;
  }
  .vastbase .title span, .openGauss .title span{
    font-size: 16px;
    color: #ff821c;
  }
  .vastbase-list{
    display: flex;
    align-items: center;
    /* background: #fff; */
    background-color: rgba(255, 255, 255, 0.6); /* 50% 透明度 */
    padding: 40px 0;
    border-radius: 8px;
  }
  .vastbase-list li{
    width: 30%;
    padding: 0 20px;
  }
  .vastbase-list .name {
    font-size: 14px;
    line-height: 14px;
    font-weight: 600;
    border-left: 2px solid #ff821c;
    padding-left: 8px;
    margin-bottom: 16px;
  }
  .vastbase-list .text {
    font-size: 12px;
    padding-left: 10px;
    color: #6f7070;
    overflow: hidden;
    word-wrap: break-word;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .openGauss-list li .name{
    font-size: 14px;
    line-height: 14px;
    font-weight: 600;
    border-left: 2px solid #ff821c;
    padding-left: 8px;
    margin-bottom: 16px;
  }
  .openGauss-list li .text{
    font-size: 12px;
    padding-left: 10px;
    color: #6f7070;
    overflow: hidden;
    word-wrap: break-word;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .openGauss{
    flex: 1;
    /* display: flex;
    align-items: center;
    justify-content: center; */
    padding-left: 80px;
  }
  .openGauss-ww{
    width: 94%;
  }
  .openGauss .title{
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-bottom: 1px solid #F7ECCB;
    margin-bottom: 24px;
  }
 
  .openGauss-list{
    padding: 45px 0;
    width: 80%;
    /* background-color: rgba(255, 255, 255, 0.8);  */
  }
  .openGauss-list li .name , .openGauss-list li .text{
    border-left: none;
    padding: 0;
  }
  .learn-more{
    font-size: 12px;
    color: #ff821c;
    cursor: pointer;
  }
  .procedure{
    margin-top: 70px;
  }
  .procedure ul{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .procedure ul li{
    display: flex;
    align-items: center;
  }
  .procedure ul li .backimg{
    width: 140px;
    margin: auto;
    text-align: center;
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translate(-50%,0);
  }
  .procedure ul li .content{
    width: 167px;
    height: 200px;
    background-image: linear-gradient(bottom,#fff,#faeddb);
    border-radius: 8px;
    border: 1px solid #fff;
  }
  .procedure .content{
    text-align: center;
  }
  .procedure h4{
    margin: 0;
    padding: 130px 0 14px;
  }
  .procedure .content p{
    font-size: 13px;
    color: #99989a;
    text-align: center;
  }
  .jiantou{
    width: 20px;
    height: 20px;
    margin: 0 10px;
  }

  .curriculum{
    position: relative;
  }
  .zjiant{
    position: absolute;
    top: 50%;
    left: -68px;
    transform: translate(0,-50%);
  }
  .yjiant{
    position: absolute;
    top: 50%;
    right: -54px;
    transform: translate(0,-50%);
  }
  .zjiant img{
    width: 36px;
  }
  .yjiant img{
    width: 36px;
  }
  .testingCenter{
    background: #fff;
    padding: 24px;
    border-radius: 8px;
    display: flex;
    align-items: flex-start;
    margin: 30px auto 40px;
  }
  .testingCenter-left{
    width: 55%;
    margin-right: 20px;
    cursor: pointer;
  }
  .testingCenter-left .exam-img{
    width: 100%;
    height: 300px;
    position: relative;
    overflow: hidden;
    border-radius: 6px;
  }
  .testingCenter-left .exam-img img{
    width: 100%;
    transition: transform 1s;
  }
  .testingCenter-left .exam-img:hover img {
    transform: scale(1.05);
  }
  .testingCenter-left .title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 14px 0 10px;
  }
  .testingCenter-left .title p{
    font-size: 15px;
    font-weight: 600;
  }
  .testingCenter-left .title p:hover{
    color: #ff821c;
  }
  .testingCenter-left .title .icon{
    width: 18px;
    height: 18px;
  }
  .testingCenter-left .on-line{
    display: flex;
    align-items: center;
  }
  .testingCenter-right{
    flex: 1;
  }
  .testingCenter-right .on-line{
    display: flex;
    align-items: center;
  }
  .testingCenter-left .on-line .type{
    font-size: 10px;
    color: black;
    width: 54px;
    height: 20px;
    border-radius: 4px;
    background: #fff2e9;
    color: #f15903;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 6px;
  }
  .testingCenter-right .on-line .type{
    font-size: 10px;
    color: black;
    width: 54px;
    height: 20px;
    border-radius: 4px;
    background: #fff2e9;
    color: #f15903;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 6px;
  }
  .testingCenter-left .on-line .time{
    font-size: 12px;
    line-height: 12px;
    color: #c4c3c6;
    margin-left: 12px;
    margin-left: 4px;
  }
  .testingCenter-right .on-line .time{
    font-size: 12px;
    line-height: 12px;
    color: #c4c3c6;
    margin-left: 12px;
    margin-left: 4px;
  }
  .el-divider--horizontal{
    margin: 16px 0;
  }
  .introduce{
    font-size: 12px;
    color: #686868;
    overflow: hidden;
    word-wrap: break-word;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .infinite-list-div{
    width: 180px;
    height: 102px;
    border-radius: 6px;
    margin-right: 16px;
    position: relative;
    overflow: hidden;
  }
  .testingCenter-right img{
    width: 100%;
    transition: transform 1s; /* 变化持续时间和动画曲线 */
  }
  .testingCenter-right:hover img{
    transform: scale(1.05);
  }
  .infinite-list{
    height: 433px;
  }
  /* 隐藏垂直滚动条 */
  .infinite-list::-webkit-scrollbar {
    width: 0;
  }
  .infinite-list-item{
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    cursor: pointer;
  }
  .infinite-list-item .content{
    flex: 1;
  }
  .infinite-list-item .content .title{
    font-size: 14px;
    color: black;
    margin-bottom: 8px;
    font-weight: 600;
  }

  .problem{
    margin-top: 30px;
  }
  .el-collapse{
    border: none;
  }
  .problem /deep/ .el-collapse-item{
    border: 1px solid #e8e8e8;
    margin-bottom: 20px;
    border-radius: 8px;
    padding: 10px 0;
  }
  .problem /deep/  .el-collapse-item__header{
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .problem /deep/ .el-collapse-item__header,.problem /deep/ .el-collapse-item__wrap{
    padding:0 20px;
    border: none;
  }
  .problem /deep/ .el-collapse-item__content{
    padding-bottom: 10px;
  }
  .questions-and-answers{
    width: 60px;
    height: 21px;
    border-radius: 30px;
    background: #fef2e6;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
  }
  .questions-and-answers img{
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }
  .questions-and-answers p{
    font-size: 10px;
    color: #f15903;
  }
  .titles{
    font-size: 15px;
    color: #333;
    font-weight: 600;
  }
  .problem .text{
    font-size: 13px;
    color: #7f7f7f;
  }
  .problem .is-active{
    box-shadow: 0px 9px 26px 1px #E2E7E7;
  }

  .product{
    height: 200px;
    background-image: url('../../assets/img/back4.png');
    background-repeat: no-repeat;
    background-position: center right;
    background-size: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .product h2{
    margin-top: 0;
  }
  .product .button{
    text-align: center;
    margin-top: 30px;
  }

  .enroll-list{
    margin-bottom: 24px;
  }
  .enroll-list ul{
    display: flex;
    align-items: center;
    flex-wrap: wrap;

  }
  .enroll-list ul li{
    margin-bottom: 16px;
    margin-right: 13px;
    width: 32%;
    transition: transform 0.3s ease-in-out; /* 动画持续时间和动画类型 */
    transform: translateY(0); /* 初始状态，不移动 */
  }
  .enroll-list ul li:hover{
    transform: translateY(-10px);
    box-shadow: 0 0 20px rgba(222, 207, 207, 0.8);
    border-radius: 6px;
  }
  .enroll-list-play{
    position: relative;
    cursor: pointer;
  }
  .enroll-list-icon{
    position: absolute;
    bottom: 20px;
    left: 20px;
    width: 10px;
    height: 10px;
    padding: 10px;
    border-radius: 50%;
    background-color: rgba(6, 6, 6, 0.3);
  }
  .enroll-list-img{
    width: 100%;
    /* height: 160px; */
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  .enroll-list-content{
    border: 1px solid #e8e8eb;
    border-top: none;
    padding: 10px 12px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
  .enroll-list-name{
    font-size: 14px;
    color: black;
    margin-bottom: 12px;
    font-weight: 600;
  }
  .enroll-list-time{
    font-size: 12px;
    color: #adadad;
  }
  .enroll-list-time span{
    margin: 0 8px;
  }
  .enroll-list-abstract{
    font-size: 12px;
    color: #8a8a8a;
    border-top: 1px solid #eaebed;
    margin: 12px 0;
    padding: 12px 0 0;
    overflow: hidden;
    word-wrap: break-word;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .enroll-list-intotal-number{
    font-size: 12px;
    padding: 5px 12px;
    border-radius: 20px;
    color: #f16418;
    border: 1px solid #f9c3a3;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue